import React from "react";
import Dots from "react-activity/lib/Dots";
import "../../style/dots.css";

const CenteredDots = (props) =>{
   return (
       <div className="text-center">
           {
               props.text?
                   <p>{props.text}</p>
                   :
                   null
           }
           <Dots/>
       </div>
   )
};

export default CenteredDots;

